import { QuestionType } from "api/landlord-surveys/types/questions";
import { DraftSurveyTemplateQuestion } from "../../types";
import {
  YesNoPreview,
  RadioPreview,
  MultiselectPreview,
  LongTextPreview,
  DatePreview,
  FilePreview,
  AddressPreview
} from "shared/app/land-x/widgets";

export const QuestionInput = ({
  question,
  answer,
  onAnswer
}: {
  question: DraftSurveyTemplateQuestion;
  answer: string | string[] | undefined;
  onAnswer: (value: string | string[]) => void;
}) => {
  const optionStrings =
    "options" in question && question.options
      ? question.options.map((o) => o.value)
      : [];
  const strVal = typeof answer === "string" ? answer : "";
  const arrVal = Array.isArray(answer) ? answer : [];

  switch (question.type) {
    case QuestionType.YES_NO:
      return (
        <YesNoPreview
          options={optionStrings}
          selected={strVal}
          onSelect={onAnswer}
        />
      );
    case QuestionType.RADIO_GROUP:
      return (
        <RadioPreview
          options={optionStrings}
          selected={strVal}
          onSelect={onAnswer}
        />
      );
    case QuestionType.CHECKBOX_MULTI:
      return (
        <MultiselectPreview
          options={optionStrings}
          selected={arrVal}
          onToggle={(opt) => {
            const next = arrVal.includes(opt)
              ? arrVal.filter((s) => s !== opt)
              : [...arrVal, opt];
            onAnswer(next);
          }}
        />
      );
    case QuestionType.LONG_TEXT:
      return <LongTextPreview value={strVal} onChange={onAnswer} />;
    case QuestionType.DATE:
      return <DatePreview value={strVal} onChange={onAnswer} />;
    case QuestionType.FILE_SINGLE:
      return (
        <FilePreview
          value={strVal || undefined}
          token=""
          onSelect={(v) => onAnswer(v)}
          onUploadingChange={() => {}}
          onDocumentReady={() => {}}
        />
      );
    case QuestionType.ADDRESS:
      return <AddressPreview value={strVal} onChange={onAnswer} />;
    default:
      return null;
  }
};
